import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';
import { PracticeReseveContext } from '../../../../PracticeReseveContext';


function PracticeReserveSelectInstructorModalSelected(props: any) {
  const isPc = useContext(cmnContext).isPc;
  const { instId, setInstId } = useContext(PracticeReseveContext);

  const selectInst = props.selectInst;
  const jaRandomInstructor = props.jaRandomInstructor;

  const [dispSelected, setDispSelected] = useState<string>('');


  useEffect(() => {
    let newDispSelected = '';
    if(instId == jaRandomInstructor.inst_id) {
      // 講師を選択しない(日本語可)
      newDispSelected = jaRandomInstructor.name;
    } else if(selectInst) {
      // 講師選択
      newDispSelected = `${selectInst?.name} （${selectInst?.schedule_count}枠）`;
    }
    setDispSelected(newDispSelected);
  }, [instId, selectInst])


  return (
    <>
      {/* 選択中 */}
      {dispSelected &&
        <>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isPc? '0 20px' : '0 10px',
          }}>
            <div>
              <span style={{fontWeight: 'bold'}}>【選択中】</span><br />
              <span>{dispSelected}</span>
            </div>
            <div
              className='btn btn-sm btn-danger'
              style={{
                padding: '5px 10px',
                marginLeft: '5px',
              }}
              onClick={() => {setInstId('');}}
            >取消</div>
          </div>
          <hr style={{margin: '5px 0'}} />
        </>
      }
    </>
  );
}
  
export default PracticeReserveSelectInstructorModalSelected;